<template>
  <div id="aboutcourier" class="flex-full">
    <section class="header">
      <img
        class="header__img"
        width="1920"
        height="385"
        loading="eager"
        fetchpriority="high"
        :src="store.background"
        alt="banner"
      >
    </section>
    <div class="container">
      <section class="content col-sm-10 col-md-7 col-xs-12">
        <div class="content__content">
          <h1 class="content__title">{{ $t(store.title) }}</h1>
          <p class="content__subtitle">{{ $t(store.subtitle) }}</p>
        </div>
        <form @submit.prevent="addResume" novalidate>
          <div class="content-list-item-block-content isActive">
            <div class="content-list-item-block-content-form isActive" ref="form">
              <!-- Location field -->
              <base-select
                name="locations_select"
                id="locations_select"
                class="content-list-item-block-content-form-field px10 border-box brdr-cl-primary brdr-1 content-list-item-block-content-form-field-select"
                @blur="$v.formData.selectedLocation.$touch()"
                :options="listLocations"
                :selected="formData.selectedLocation"
                :placeholder="$t('City *')"
                :validations="[{
                  condition: !$v.formData.selectedLocation.required && $v.formData.selectedLocation.$error,
                  text: $t('Field is required')
                }]"
                v-model="formData.selectedLocation"
              />
              <div class="content-list-item-block-content-form__name-section">
                <!-- Firstname field -->
                <base-input
                  class="base-input-small content-list-item-block-content-form-field"
                  type="text"
                  autocomplete="given-name"
                  name="first-name"
                  @blur="$v.formData.firstname.$touch()"
                  :placeholder="`${$t('First name')} *`"
                  :maxlength="50"
                  :validations="[
                    {
                      condition: !$v.formData.firstname.required && $v.formData.firstname.$error,
                      text: $t('Field is required')
                    },
                    {
                      condition: !$v.formData.firstname.minLength,
                      text: $t('First name must have at least 2 letters.')
                    }
                  ]"
                  v-model.trim="formData.firstname"
                />
                <!-- Lastname field -->
                <base-input
                  class="base-input-small content-list-item-block-content-form-field"
                  type="text"
                  name="last-name"
                  autocomplete="family-name"
                  @blur="$v.formData.lastname.$touch()"
                  :placeholder="`${$t('Last name')} *`"
                  :maxlength="50"
                  :validations="[
                    {
                      condition: !$v.formData.lastname.required && $v.formData.lastname.$error,
                      text: $t('Field is required')
                    },
                    {
                      condition: !$v.formData.lastname.minLength,
                      text: $t('Last name must have at least 2 letters.')
                    }
                  ]"
                  v-model.trim="formData.lastname"
                />
              </div>
              <!-- Email address field -->
              <base-input
                class="base-input-small content-list-item-block-content-form-field"
                type="email"
                name="email"
                autocomplete="email"
                @blur="$v.formData.email.$touch()"
                :placeholder="`${$t('Email address')} *`"
                :validations="[
                  {
                    condition: !$v.formData.email.required && $v.formData.email.$error,
                    text: $t('Field is required')
                  },
                  {
                    condition: !$v.formData.email.email,
                    text: $t('Please provide valid e-mail address.')
                  }
                ]"
                v-model.trim="formData.email"
              />
              <!-- Phone number field -->
              <base-telephone-input
                class="base-input-small content-list-item-block-content-form-field"
                :required="true"
                :validations="phoneValidations"
                :value="formData.phone"
                @update="updatePhoneNumber"
                @input="$v.formData.phone.$touch()"
              />
              <!-- Password field -->
              <base-input
                class="base-input-small content-list-item-block-content-form-field"
                type="password"
                name="password"
                autocomplete="new-password"
                @blur="$v.formData.password.$touch()"
                :placeholder="`${$t('Desired password')} *`"
                :minlength="8"
                :maxlength="50"
                :validations="[
                  {
                    condition: !$v.formData.password.required && $v.formData.password.$error,
                    text: $t('Field is required')
                  },
                  {
                    condition: $v.formData.password.required && !$v.formData.password.minLength,
                    text: $t('The password needs at least 8 characters. Create a new password and try again.')
                  }
                ]"
                v-model.trim="formData.password"
              />
              <!-- Desired Password field -->
              <base-input
                class="base-input-small content-list-item-block-content-form-field"
                type="password"
                name="password-confirm"
                autocomplete="new-password"
                @blur="$v.formData.rePassword.$touch()"
                :placeholder="`${$t('Repeat desired password')} *`"
                :minlength="8"
                :maxlength="50"
                :validations="[
                  {
                    condition: !$v.formData.rePassword.required && $v.formData.rePassword.$error,
                    text: $t('Field is required')
                  },
                  {
                    condition: $v.formData.rePassword.required && !$v.formData.rePassword.sameAsPassword,
                    text: $t('Passwords must be identical.')
                  }
                ]"
                v-model.trim="formData.rePassword"
              />
              <!-- Transport field -->
              <base-select
                name="transport_select"
                id="transport_select"
                class="content-list-item-block-content-form-field px10 border-box brdr-cl-primary brdr-1 content-list-item-block-content-form-field-select"
                @blur="$v.formData.selectedTransport.$touch()"
                :options="listTransport"
                :selected="formData.selectedTransport"
                :placeholder="$t('Transport *')"
                :validations="[{
                  condition: !$v.formData.selectedTransport.required && $v.formData.selectedTransport.$error,
                  text: $t('Field is required')
                }]"
                v-model="formData.selectedTransport"
              >
              </base-select>
            </div>
          </div>
          <div class="content-list-item-block-footer">
            <!-- Attach file -->
            <div class="content-list-item-block-footer-file">
              <a class="content-list-item-block-content-form-file-title no-underline"
                 @click="$refs.fileInput.click()"
              > {{ $t('Attach resume') }} </a>
              <input
                type="file"
                hidden
                class="content-list-item-block-content-form-file-field"
                ref="fileInput"
                accept=".doc, .docs, .pdf, .png"
                @change="uploadFile"
              >
              <span class="content-list-item-block-content-form-file-text"> {{ formData.fileName }} </span>
            </div>

            <base-checkbox
              class="mb10"
              id="terms"
              v-model="formData.conditions"
              @blur="$v.formData.conditions.$reset()"
              @change="$v.formData.conditions.$touch()"
              :validations="[{
                condition: !$v.formData.conditions.required && $v.formData.conditions.$error,
                text: $t('You must accept the terms and conditions.')
              }]"
            >
              {{ $t('I agree to') }}
              <span class="link pointer" @click.prevent="openTermModal">
                {{ $t('Terms and conditions') }}
              </span>
            </base-checkbox>
            <button-full
              class="content-list-item-block-footer-btn"
              :disabled="!!isCourierEnrollment"
              type="submit"
            >
              {{ $t('Send') }}
            </button-full>
          </div>
        </form>
      </section>
    </div>
    <modal-terms-of-use :showModal="showModal" />
  </div>
</template>

<script async>
import backgroundImage from 'theme/directives/background-image';
import BaseSelect from 'theme/components/core/blocks/Form/BaseSelect.vue';
import BaseInput from 'theme/components/core/blocks/Form/BaseInput.vue';
import BaseCheckbox from 'theme/components/core/blocks/Form/BaseCheckbox.vue';
import ButtonFull from 'theme/components/theme/ButtonFull.vue';
import ModalTermsOfUse from 'theme/components/core/blocks/Checkout/ModalTermsOfUse.vue';
import { s3Path } from '@vue-storefront/core/helpers';
import { mapActions, mapGetters } from 'vuex';
import { email, minLength, required, sameAs } from 'vuelidate/lib/validators';
const BaseTelephoneInput = () => import(/* webpackChunkName: "vsf-base-telephone-input" */ 'theme/components/core/blocks/Form/BaseTelephoneInput.vue');

export default {
  name: 'AboutCourier',
  components: {
    ModalTermsOfUse,
    ButtonFull,
    BaseCheckbox,
    BaseInput,
    BaseSelect,
    BaseTelephoneInput
  },
  directives: {
    backgroundImage
  },
  data: () => ({
    store: {
      background: '../../../assets/Courier/Banners/1.png',
      title: 'Join the Korzyna courier partner community today!',
      subtitle: 'Fill out the short form below and start your journey with Korzyna!'
    },
    formData: {
      firstname: '',
      lastname: '',
      phone: '',
      email: '',
      file: null,
      fileName: '',
      password: '',
      rePassword: '',
      selectedLocation: '',
      selectedTransport: '',
      conditions: false
    },
    showModal: false,
    phoneMeta: {
      isValid: false
    }
  }),
  computed: {
    ...mapGetters({
      locations: 'locations/getLocations',
      currentLocation: 'locations/getActiveLocation',
      currentLocationMeta: 'locations/getCurrentLocationMeta',
      transport: 'transport/getTransport',
      courierEnrollment: 'configs/getConfigCourierEnrollment'
    }),
    listLocations () {
      return this.locations.map(location => {
        return {
          value: location.code,
          label: location.name
        }
      })
    },
    listTransport () {
      return this.transport.map(trans => {
        return {
          value: trans.id.toString(),
          label: trans.name
        }
      })
    },
    isCourierEnrollment () {
      let isPresent = this.courierEnrollment.find(meta => meta.key === 'disable_courier_enrollment')
      return isPresent ? isPresent.value : false
    },
    phoneValidations () {
      return [
        {
          condition: this.$v.formData.phone.$error && !this.$v.formData.phone.required,
          text: this.$t('Field is required.')
        },
        {
          condition: this.$v.formData.phone.$error && this.$v.formData.phone.required && !this.$v.formData.phone.isValid,
          text: this.$t('Incorrect type of number')
        }
      ]
    }
  },
  methods: {
    ...mapActions({
      loadLocations: 'locations/loadLocations',
      loadActiveTransport: 'transport/loadActiveTransport',
      sendApplication: 'vacancies/createApplicant'
    }),
    s3Path,
    updatePhoneNumber (value) {
      this.phoneMeta = value;

      if ('formattedNumber' in value) {
        this.formData.phone = value.formattedNumber;
      }
    },
    uploadFile (event) {
      const applyFile = event.target.files[0]
      if (applyFile !== undefined) {
        this.formData.file = event.target.files[0]
        this.formData.fileName = applyFile.name
      }
    },
    async addResume () {
      if (this.$v.$invalid) {
        this.$v.formData.$touch()
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: this.$t('Some of the form fields are not valid!'),
          action1: { label: this.$t('OK') }
        })
        return
      }

      let payload = {
        userPersonalData: {
          user: {
            location_code: this.formData.selectedLocation,
            first_name: this.formData.firstname,
            last_name: this.formData.lastname,
            phone_number: this.formData.phone,
            email: this.formData.email,
            password: this.formData.password,
            password_confirmation: this.formData.rePassword,
            transport_id: this.formData.selectedTransport
          },
          file: this.formData.file,
          fileName: this.formData.fileName
        }
      }
      await this.sendApplication(payload).then(res => {
        if (res.code !== 200) {
          let message = res.result.message.replace(this.formData.email, '{email}');
          this.$store.dispatch('notification/spawnNotification', {
            type: 'error',
            message: this.$t(message, {email: this.formData.email}),
            action1: { label: this.$t('OK') }
          })
        } else {
          this.onSuccesfulSubmission()
        }
        return res
      })

      this.clearAllFormFields()
    },
    onSuccesfulSubmission () {
      this.$store.dispatch('notification/spawnNotification', {
        type: 'success',
        message: this.$t("Thank you for the registration. Wait for the operator's call and further instructions."),
        action1: { label: this.$t('OK') }
      })
    },
    clearAllFormFields () {
      this.formData.firstname = ''
      this.formData.lastname = ''
      this.formData.phone = ''
      this.formData.email = ''
      this.formData.password = ''
      this.formData.rePassword = ''
      this.formData.selectedLocation = ''
      this.formData.selectedTransport = ''
      this.formData.file = null
      this.formData.fileName = ''
      this.formData.conditions = false
      this.$v.$reset();
    },
    openTermModal () {
      this.$bus.$emit('modal-toggle', 'modal-terms')
      this.showModal = true
    }
  },
  async mounted () {
    this.formData.selectedLocation = !this.currentLocation || typeof this.currentLocation === 'undefined' ? 'ternopil' : this.currentLocation.code
    if (this.transport && this.transport.length) {
      this.formData.selectedTransport = this.transport && this.transport.length ? this.transport[0].id.toString() : ''
    } else {
      await this.loadActiveTransport().then(() => {
        this.formData.selectedTransport = this.transport && this.transport.length ? this.transport[0].id.toString() : ''
      })
    }
  },
  beforeMount () {
    if (this.isCourierEnrollment) {
      this.$router.push({ name: 'home' });
    }
  },
  beforeDestroy () {
    this.clearAllFormFields();
  },
  metaInfo () {
    if (this.currentLocationMeta) {
      const currentLocationMeta = [
        ...(this.currentLocationMeta.meta_title
          ? [{
            vmid: 'title',
            name: 'title',
            content: this.currentLocationMeta.meta_title
          }]
          : []),
        ...(this.currentLocationMeta.meta_description
          ? [{
            vmid: 'description',
            name: 'description',
            content: this.currentLocationMeta.meta_description
          }]
          : []),
        ...(this.currentLocationMeta.meta_keywords
          ? [{
            vmid: 'keywords',
            name: 'keywords',
            content: this.currentLocationMeta.meta_keywords
          }]
          : []),
        ...(this.currentLocationMeta.og_meta_type
          ? [{
            vmid: 'og:type',
            property: 'og:type',
            content: this.currentLocationMeta.og_meta_type
          }]
          : []),
        ...(this.currentLocationMeta.og_meta_title
          ? [{
            vmid: 'og:title',
            property: 'og:title',
            content: this.currentLocationMeta.og_meta_title
          }]
          : []),
        ...(this.currentLocationMeta.og_meta_description
          ? [{
            vmid: 'og:description',
            property: 'og:description',
            content: this.currentLocationMeta.og_meta_description
          }]
          : []),
        ...(this.currentLocationMeta.og_meta_image
          ? [{
            vmid: 'og:image',
            property: 'og:image',
            content: this.currentLocationMeta.og_meta_image
          }]
          : [])
      ]

      return {
        ...(this.currentLocationMeta.meta_title && { title: this.currentLocationMeta.meta_title }),
        meta: currentLocationMeta,
        link: [
          { rel: 'preload', as: 'image', href: '../../../assets/Courier/Banners/1.png' }
        ]
      }
    }

    return {
      link: [
        { rel: 'preload', as: 'image', href: '../../../assets/Courier/Banners/1.png' }
      ]
    }
  },
  validations () {
    return {
      formData: {
        selectedLocation: {
          required
        },
        lastname: {
          required,
          minLength: minLength(2)
        },
        firstname: {
          required,
          minLength: minLength(2)
        },
        email: {
          required,
          email
        },
        phone: {
          required: () => required && 'phoneNumber' in this.phoneMeta,
          isValid: () => this.phoneMeta.isValid
        },
        password: {
          required,
          minLength: minLength(8)
        },
        rePassword: {
          required,
          sameAsPassword: sameAs('password')
        },
        selectedTransport: {
          required
        },
        conditions: {
          required
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
h1 {
  font-size: 36px;
}

.base-input-small {
  min-height: 3.5rem;
}

.header {
  height: 385px;

  &__img {
    width: 100%;
    display: block;
    object-fit: none;
    object-position: bottom;
  }

  @media only screen and (max-width: 768px) {
    height: 280px;
    overflow: hidden;
    position: relative;

    &__img {
      object-fit: cover;
      object-position: center;
      height: 340px;
      position: absolute;
      bottom: 0;
    }
  }

  @media only screen and (max-width: 600px) {
    height: 240px;

    &__img {
      height: 300px;
    }
  }
}

.content {
  margin: 48px auto 0;

  &__content {
    text-align: left;
    margin: 0 auto 24px;
  }

  &__title,
  &__subtitle {
    margin: 0;
  }

  &__title {
    margin-bottom: 26px;
  }

  &__subtitle {
    font-size: 18px;
    margin-bottom: 16px;
  }
}

.content-list-item {
  &-block {
    padding: 20px;

    border-top-right-radius: 5px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    background-color: #f5f5f5;

    &-select {
      &-small {
        min-height: 3.5rem;
      }
    }

    &-btn {
      padding: 7px 22px 7px 40px;
      position: relative;

      color: #fff;
      font-size: 14px;
      font-weight: 600;

      background-color: #11bb2e;
      border-radius: 25px;
      border: none;
      outline: none;

      transition: .2s;

      &:hover {
        cursor: pointer;
        background-color: rgba(17, 187, 46, .8);
      }

      &.isActive:before {
        transform: rotate(180deg);
      }

      &:before {
        width: 30px;
        height: 30px;
        margin: auto;

        position: absolute;
        top: 0;
        left: -2px;
        bottom: 0;
        content: '';

        background-image: url('../assets/static/vacancies/arrow.png');
        background-position: center;
        background-size: 16px;
        background-repeat: no-repeat;

        background-color: #fff;
        border-radius: 50%;

        transition: .2s;
      }
    }

    &-content {
      margin-bottom: 20px;
      transition: .2s ease-out;

      &-description {
        margin-bottom: 20px;
        transition: .3s;

        ::v-deep p {
          margin: 0;
        }

        ::v-deep ul {
          margin: 0;
          padding: 0;
          list-style: none;

          li {
            margin-top: 6px;
            padding-left: 35px;

            position: relative;

            &:before {
              width: 23px;
              height: 23px;
              margin: auto;

              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              content: '';

              background-image: url('../assets/static/vacancies/correct.png');
              background-position: center;
              background-size: 10px 8px;
              background-repeat: no-repeat;

              background-color: #11bb2e;
              border-radius: 50%;
            }
          }
        }
      }

      &-btn {
        padding: 7px 22px 7px 40px;
        position: relative;

        color: #fff;
        font-size: 14px;
        font-weight: 600;

        background-color: #11bb2e;
        border-radius: 25px;
        border: none;
        outline: none;

        transition: .2s;
        &.isFixed {
          position: absolute;
          bottom: 10px;
        }
        &:hover {
          cursor: pointer;
          background-color: rgba(17, 187, 46, .8);
        }

        &:before {
          width: 30px;
          height: 30px;
          margin: auto;

          position: absolute;
          top: 0;
          left: -2px;
          bottom: 0;
          content: '';

          background-image: url('../assets/static/vacancies/book.png');
          background-position: center;
          background-size: 14px 17px;
          background-repeat: no-repeat;

          background-color: #fff;
          border-radius: 50%;
        }
      }

      &-form {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        transition: .2s ease-out;

        &__name-section {
          display: flex;
          align-items: center;
          column-gap: 16px;
          width: 100%;
        }

        &-field {
          width: 100%;
          margin-bottom: 10px;

          &-select {
            background: #fff;
            border-radius: 5px;
            border-color: #bdbdbd;
            margin-bottom: 24px;
            &:hover {
              border-color: rgba(17, 187, 46, .8);
            }
          }
        }

        &-file {
          width: 100%;
          height: 30px;
          margin-bottom: 20px;

          display: flex;
          justify-content: space-between;
          align-items: center;

          @media only screen and (max-width: 576px) {
            height: auto;

            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
          }

          &-title {
            padding: 8px 0 8px 40px;
            position: relative;

            color: #11bb2e;
            font-size: 14px;
            font-weight: 400;
            display: inline-block;
            margin-bottom: 4px;

            &:hover {
              cursor: pointer;
              text-decoration: underline;
            }

            &:before {
              width: 24px;
              height: 24px;
              margin: auto;

              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              content: '';

              background-image: url('../assets/static/vacancies/folder.png');
              background-position: center;
              background-size: 14px 17px;
              background-repeat: no-repeat;

              border-radius: 50%;
            }
          }

          &-field {
            display: none;
          }

          &-text {
            width: 150px;

            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            @media only screen and (max-width: 576px) {
              width: 100%;
              margin-top: 10px;
            }
          }
        }

        &-btn {
          width: auto;
          margin-top: 10px;
          min-height: 40px;
          margin-bottom: 10px;
          padding: 13px 107px 13px 135px;

          align-self: center;

          color: #fff;
          font-size: 12px;
          font-weight: 600;

          background-image: url('../assets/static/vacancies/circle-correct.png');
          background-position: 105px center;
          background-size: 22px;
          background-repeat: no-repeat;

          background-color: #11bb2e;
          border: none;
          border-radius: 5px;
          outline: none;

          transition: .2s;

          @media only screen and (max-width: 576px) {
            width: 100%;
            padding: 13px 0;
            background-position: 10px center;
          }

          &:hover {
            cursor: pointer;
            background-color: rgba(17, 187, 46, 0.8);
          }
        }
      }
    }
  }
}
</style>
